import { Tooltip } from '@ui/lib/park/ui/tooltip';
import { ReactNode } from 'react';
import { SystemStyleObject } from 'styled-system/types';

import { TooltipWithTouch } from './TooltipWithTouch';

export const TextTooltip = ({
  children,
  content,
  contentCss,
  lazyContent = true,
  triggerCss,
  ...rootProps
}: {
  content: ReactNode;
  children: ReactNode;
  contentCss?: SystemStyleObject | SystemStyleObject[];
  lazyContent?: boolean;
  triggerCss?: SystemStyleObject | SystemStyleObject[];
} & Tooltip.RootProps) => {
  // Lazy mounting is delegated to ark-ui's built-in `lazyMount` (mounts on first
  // open, stays mounted) rather than a manual mount gate. The old gate mounted
  // the Positioner a render *after* the machine opened, so the first open
  // mis-measured and the tooltip jumped to the corner; ark's lazyMount mounts at
  // the right time and positions correctly on the very first open.
  return (
    <TooltipWithTouch.Root
      variant="text"
      lazyMount={lazyContent}
      positioning={{
        placement: 'top',
      }}
      {...rootProps}
    >
      <TooltipWithTouch.Trigger asChild css={{ ...triggerCss }}>
        {children}
      </TooltipWithTouch.Trigger>
      <TooltipWithTouch.Positioner>
        <TooltipWithTouch.Content borderRadius="4px" css={{ ...contentCss }}>
          <TooltipWithTouch.Arrow>
            {/* <TooltipWithTouch.ArrowTip /> */}
          </TooltipWithTouch.Arrow>
          {content}
        </TooltipWithTouch.Content>
      </TooltipWithTouch.Positioner>
    </TooltipWithTouch.Root>
  );
};
